/*
 * @Author: hujingyang
 * @Description: 新建官方人群营销
 * @LastEditors: yang chenglin
 */

import React, { useEffect, useState } from 'react';
import { Balloon, Button, DatePicker, Dialog, Icon, Input, Message, Radio, Select } from '@alifd/next';
import style from './index.module.scss';
import icon_warning from '@/pages/OrderSelection/icon/iconWarning.svg';
import Dialog_CrowdSelected_List from '@/pages/OrderSelection/components/Dialog_CrowdSelected_List';
import Dialog_GenerateShortURL from '@/pages/OrderSelection/components/Dialog_GenerateShortURL';
import Dialog_CrowdSmsTemplate from '@/components/CrowdSmsTemplate';
import Dialog_SMSSendDetail from '@/pages/AccountKeeper/components/SMSConsumeRecord/components/Dialog_SMSSendDetail';
import SectionTitle from '@/components/SectionTitle';
import LzMsg from '@/components/common/LzMsg';
import LzDialog from '@/components/common/LzDialog';
import utils from '@/common/utils';
import { store } from '@ice/stark-data';
import { Servlets } from '@/service';
import { appHistory } from '@ice/stark-app';
import moment from 'moment';
import DisclaimerDialog from '@/components/SMS/DisclaimerDialog';

import CONSTANTS from '@/utils/constant';

const ADDLENGTH = CONSTANTS.LZ_SMS_CANCEL_WORD.length + 3;

const RadioGroup = Radio.Group;
const { TextArea } = Input;

/** 新建订单筛选营销任务 数据弹窗内容 */
const Dialog_CreateShortMesssage_content = (props: unknown): JSX.Element => {
  const [params, setParams] = useState({
    marketingType: '',
    marketingTypeText: '',
    orderCrowdType: '',
    peopleCrowdType: '',
    searchString: '',
    telList: [],
  });// 父页面传递的数据
  const [theme, setTheme] = useState('');// 营销主题value
  const [time, setTime] = useState('immediate');// 执行时间当前选项 可选值{value: 'immediate',label: '立即执行'}, {value: 'wait',label: '定时执行'}
  const [waitTime, setWaitTime] = useState();// 定时执行 时间value
  const [timeDisc, setTimeDisc] = useState([{ label: '', value: '' }]);// 人群选择 - 屏蔽设置 - 时间选择器 字典项
  const [shieldArr, setShieldArr] = useState([] as string[]);// 屏蔽设置 checkbox ["crowd" ,"blackListing"]
  const [shieldPopulation, setShieldPopulation] = useState({ value: '10001', label: '1' });// 屏蔽设置 屏蔽人数

  const [messageSignatures, setMessageSignatures] = useState('');// 短信签名

  // const [permitSetSign, setPermitSetSign] = useState(false);//是否允许用户修改短信签名
  const [messageContent, setMessageContent] = useState('');// 短信内容
  const [smsTemplateInfo, setSmsTemplateInfo] = useState({ // 选择短信模板的时候，需要暂存一些发送短信和创建活动必须的参数
    templateId: '',
    smsAccount: '',
    fullContent: '',
  });
  const [sizeLength, setSizeLength] = useState(0);// 已输入字数
  const [everyMessageNum, setEveryMessageNum] = useState(1);// 每条短信算几条
  const [openCrowdSelectedDialog, setOpenCrowdSelectedDialog] = useState(false);// 是否打开人群选择弹窗
  const [selectedCrowdData, setSelectedCrowdData] = useState({
    id: '',
    name: '人群名称',
    intro: '',
    type: '',
    createDate: '',
    keyy: '',
    size: 0,
    md5: '',
  });// 人群选择弹窗 返回的数据
  const [openShortUrlDialog, setOpenShortUrlDialog] = useState(false);// 是否打开生成短链接弹窗
  const [url, setUrl] = useState({ longUrl: '', shortUrl: '' });// 用于保存用户生成的短链接与长链接
  const [selectSmsTemplateDialog, setSelectSmsTemplateDialog] = useState(false);// 是否打开生成短链接弹窗

  const [phoneMsgSecond, setPhoneMsgSecond] = useState(''); // 发送右侧手机展示内容
  const [currentBalance, setCurrentBalance] = useState(0); // 商家当前短信余额
  const [testTel, setTestTel] = useState(''); // 商家当前短信余额
  const [openTestTelRecordDialog, setOpenTestTelRecordDialog] = useState(false);// 是否打开测试记录弹窗
  const [breadcrumbThree, setBreadcrumbThree] = useState('新建官方人群营销'); // 设置面包屑第三级别是从哪里跳来的
  const [checkSmsContent,setCheckSmsContent] = useState('');
  /** 生命周期函数 */
  useEffect(() => {
    init();
  }, []);

  /** 初始化函数 */
  const init = (): void => {
    getPageData();
    let sceneMarketingParams = store.get('sceneMarketingParams');
    // 页面异常拦截
    if (sceneMarketingParams === undefined) {
      sceneMarketingParams = JSON.parse(localStorage.getItem('sceneMarketingParams') as string);
      if (sceneMarketingParams === null) {
        // 这里给出提示
        LzMsg.error('系统异常，请返回上一页重新进入');
      }
    }
    setParams(sceneMarketingParams);
    setBreadcrumb(sceneMarketingParams.marketingTypeText);
  };

  /** 设置Header面包屑 */
  const setBreadcrumb = (name: string): void => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({
      name: '精准营销', // 一级页面名称
      url: '/web/crowdMarketing', // 一级页面url
      children: {
        name, // 二级页面名称
        url: '/web/crowdMarketing', // 二级页面url
        children: {
          name: breadcrumbThree, // 三级页面名称
          url: '/web/crowdMarketing/create', // 三级页面url
        },
      },
    });
  };

  const getPageData = (): void => {
    // 执行时间radio 数据字典
    const timeDisc = [{ value: 'immediate', label: '立即执行' }, { value: 'wait', label: '定时执行' }];
    setTimeDisc(timeDisc);
    // 获取短信签名  赋值给短信签名 和短信签名中间件
    Servlets('getTitle', {}).then((res: { data: string }) => {
      const { shopName } = res.data;
      Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        if (!res.data) {
          return;
        }
        setMessageSignatures(res.data);
      });
    });

    /** 获取短信余额 */
    getPaymentRecord();
    const fromUrl = store.get('fromUrlToCreateMarket');
    if (fromUrl === '/CustomerManagement') {
      // 初始化人群 在客户管理模块跳转来
      getCrowd();
    }
    if (fromUrl === '/Orderselection') {
      getCrowdName(); // 初始化人群 在精准营销-订单筛选营销模块跳转来
    }
  };

  // 初始化人群(如果从人群库点击"去营销"来到该页面，则初始化人群库所选人群)
  const getCrowdName = () => {
    const crowdInfo = JSON.parse(sessionStorage.getItem('LzCrowdMarket'));
    if (crowdInfo.id !== '' || crowdInfo.id !== null || crowdInfo.id !== undefined) {
      setSelectedCrowdData({
        id: crowdInfo.id,
        name: crowdInfo.name,
        size: crowdInfo.size,
        type: crowdInfo.type,
      });
    }
  };

  // 初始化人群(如果从人群库点击"去营销"来到该页面，则初始化人群库所选人群)
  const getCrowd = () => {
    const crowdInfo = JSON.parse(sessionStorage.getItem('LzCrowdMarket'));
    if (crowdInfo.id !== '' || crowdInfo.id !== null || crowdInfo.id !== undefined) {
      setSelectedCrowdData({
        keyy: crowdInfo.keyy,
        name: crowdInfo.name,
        size: crowdInfo.size,
        type: crowdInfo.type,
        esJson: crowdInfo.esJson,
        id: crowdInfo.id,
        md5: crowdInfo.md5,
      });
    }
  };

  /** 获取短信余额 */
  const getPaymentRecord = (isReFresh = false) => {
    Servlets('getPageSmsNum').then((res: { data: number }) => {
      if (res.data === undefined) {
        return;
      }
      setCurrentBalance(res.data);
      if (isReFresh) Message.success('余额已刷新');
    });
  };

  // /**
  //  * @description:
  //  * @param {*}
  //  * @return {*}
  //  */
  // const everyCheck = () => {
  //   let tempCount = 1;
  //   const sizeLength = messageContent.length;
  //   if (+sizeLength <= 70 && sizeLength !== 0) {
  //     tempCount = Math.ceil(+sizeLength / 70);
  //   } else if (+sizeLength > 70) {
  //     tempCount = Math.ceil(+sizeLength / 67);
  //   }
  //   setEveryMessageNum(tempCount);
  // };
  // // messageContent变化 触发everyCheck
  // useEffect(() => {
  //   everyCheck();
  // }, [messageContent]);
  /** 设置营销主题 value */
  const setThemeValue = (val: string): void => {
    setTheme(val);
  };
  /** 设置测试手机号 value */
  const setTestTelFunc = (val: string): void => {
    setTestTel(val);
  };

  /** 设置执行时间 value */
  const setTimeValue = (val: string): void => {
    setTime(val);
  };
  /** 设置定时执行时间 value */
  const setWaitTimeValue = (val: any): void => {
    setWaitTime(val);
  };

  /** 获取天数选择器 数据字典 */
  const getDataSource = (): object[] => {
    const dataSource = [
      { value: '10001', label: '1' },
      { value: '10003', label: '3' },
      { value: '10007', label: '7' },
      { value: '100015', label: '15' },
      { value: '100030', label: '30' },
      { value: '1000180', label: '180' },
      { value: '1000365', label: '365' },
    ];
    return dataSource;
  };

  /** 人群选择 - 屏蔽设置选择器触发事件 */
  const handleSelectChange = (value: string, actionType, item): void => {
    const shieldTemp = shieldArr;

    // 判断当前屏蔽设置是否已开启
    if (shieldArr.includes('crowd')) {
      shieldTemp.push('crowd');
      setShieldArr(shieldTemp);
    }
    setShieldPopulation(item);
  };

  /** 投放内容 - 短信内容 textArea输入 触发 */
  const handleTextAreaOnChange = (value: string): void => {
    setMessageContent(value);
  };

  /**
   *  从子 弹窗中获取用户已选的人群信息
   * @param data
   * @param selected 判断用户是否选择了人群
   */
  const getCrowdSelectedData = (data: any, selected: boolean): void => {
    setOpenCrowdSelectedDialog(false);
    if (selected) {
      // 如果从子页面返回的是false，表明用户没有选择人群，而是关闭了弹窗
      setSelectedCrowdData(data);
    }
  };

  /**
   * 打开生成短链接弹窗
   */
  const handleOpenShortUrlDialog = (): void => {
    setOpenShortUrlDialog(true);
  };

  /**
   * 打开生成短链接弹窗
   */
  const handleSelectSmsTemplateDialog = (): void => {
    setSelectSmsTemplateDialog(true);
  };

  /**
   * @description: 选择短信模板
   * @param {*} tmp 所选数据
   * @return {*}
   */
  const dealSmsContent = (tmp) => {
    setMessageContent(`【${messageSignatures}】${tmp.templateShowContent}`);
    setSizeLength(tmp.smsSplitNum ? tmp.smsSplitNum.split('/')[0]:0);
    setEveryMessageNum(tmp.smsSplitNum ? tmp.smsSplitNum.split('/')[1]:1);
    setCheckSmsContent(tmp.templateContent);
    setSmsTemplateInfo({
      ...smsTemplateInfo,
      templateId: tmp.templateId,
      smsAccount: tmp.smsAccount,
      fullContent: tmp.fullContent,
    });
    setSelectSmsTemplateDialog(false);
  };

  /** 展示短信内容 */
  const showModifyTelDialog = (record: {} = {}): void => {
    const dataSourceSelect = [
      { value: '10001', label: '18342216827' },
      { value: '10002', label: '15941158869' },
      // { value: 10003, label: 'Tom Cat', disabled: true },
      // {
      //     label: 'Special Group', children: [
      //         { value: -1, label: 'FALSE' },
      //         { value: 0, label: 'ZERO' }
      //     ]
      // }
    ];

    const dialog = Dialog.show({
      title: '测试手机号修改',
      className: 'quickDialog_hjy',
      content: (
        <div>
          <div style={{ display: 'flex' }}>
            <Icon type="prompt" size="small" style={{ color: '#f0b447', marginRight: 8 }} />
            <div>
              <p>1.测试短信手机号不受频控限制，最多选择三个，您也可以手动输入点选</p>
              <p>2.修改完成后立即生效；注意！测试手机号的修改会应用到全部渠道</p>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '20px' }}>
            <span style={{ lineHeight: '30px' }}> 短信测试手机号：</span>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Select
                mode="tag"
                defaultValue={['10001']}
                onChange={(value) => {
                  console.log(value);
                }}
                dataSource={dataSourceSelect}
                style={{ width: 380, marginBottom: 20 }}
              />
              <Button type="primary" text>短信发送使用教程</Button>
            </div>
          </div>
        </div>
      ),
      footer: (
        <div>
          <Button
            className="close"
            type="secondary"
            style={{ marginRight: 15 }}
            onClick={() => ModifyTelVerify(dialog)}
          >确认
          </Button>
          <Button className="close" type="normal" onClick={() => dialog.hide()}>关闭</Button>
        </div>
      ),
      // 点击右上角关闭x时触发
      onClose: (trigger, event) => {

      },
    });
  };

  /** 修改手机号弹窗校验 */
  const ModifyTelVerify = (dialog): void => {
    Message.success('修改成功');
    dialog.hide();
  };

  /** 修改短信签名 */
  const ModifyMessageSignatures = () => {

  };

  /** 发送测试 测试短信接收人电话 */
  const sendTestTel = () => {
    if (!testTel) {
      Message.warning('请输入您的手机号码后发送测试！');
    }

    if (!utils.telphoneVerification(testTel)) {
      Message.warning('请正确填写您的手机号码！');
      return;
    }

    const fullContent = {
      fullContent: messageContent.replace(`【${messageSignatures}】`, ''),
      mobile: testTel,
      channelType: 1, // 短信类型：0-营销类 1-关怀类
      replace: 1, // 是否手动替换（只有关怀类短信能替换）0-是 1-否。这个对于营销类没什么意义，且现在都不可替换，所以写死1。
      sign: messageSignatures,
      smsAccount: smsTemplateInfo.smsAccount,
      templateId: smsTemplateInfo.templateId,
      templateParam: '', // 这个参数暂时用不到，后端写死了一个值，前端先传空备用
    };
    Servlets('sendTestsms', fullContent).then((res) => {
      if (res.success) {
        LzMsg.success('发送成功')
      }else {
        LzMsg.error(res.resp_msg);
      }
    }).catch((e) => {
      console.log(e);
      LzMsg.error(e.message);
    });
  };

  /** 返回上一页 */
  const goBackPrePage = (): void => {
    // 返回上一页
    appHistory.push(store.get('newSetBreadcrumb')[1].url);
  };

  /** 立即充值 */
  const immediatelyPrepaid = () => {
    console.log(window.location);
    appHistory.push('../accountKeeper');
  };
  /** 刷新余额 */
  const refreshPrepaid = () => {
    getPaymentRecord(true);
  };

  /** 【封装】 营销表单数据 */
  const packagingData = (): object => {
    /** 执行类型 */
    let excuteType;
    let excuteTime;
    switch (time) {
      case 'immediate':// 立即执行
        excuteType = '0';
        excuteTime = `${new Date().getTime()}`;// 设置为当前时间戳
        break;

      case 'wait':// 定时执行+
        excuteType = '1';
        excuteTime = waitTime ? moment(waitTime as any * 1000).unix() : '';// 设置为当前时间戳
        break;

      default:
        excuteType = '';
        excuteTime = '';
        break;
    }
    const formData = {
      marketingType: params.marketingType, // "营销类型 1-人群营销 2-订单筛选营销",
      name: theme, // "活动名称【营销主题】",
      excuteType, // "执行类型 0-立即执行 1-定时执行",
      excuteTime, // "执行时间",
      excludeBlacklist: shieldArr.includes('blackListing') ? '1' : '0', // "屏蔽营销黑名单 0-不屏蔽 1-屏蔽",
      excludePassedCrowdDays: shieldArr.includes('blackLicrowdsting') ? shieldPopulation.label : '0', // "屏蔽近n天已营销人群（不屏蔽时为0）",
      longUrl: url.longUrl, // "长链接",
      shortUrl: url.shortUrl, // "短链接",
      smsContent: checkSmsContent, // "短信内容",
      smsSign: messageSignatures, // "短信签名",
      crowdId:params.crowdId ? params.crowdId :  selectedCrowdData.crowdId,
      crowdName: selectedCrowdData.name,
      expectPeopleNum: selectedCrowdData.size,
      peopleCrowdType: selectedCrowdData.type, // "人群营销下的人群类型 1-标签策略 2-手动上传",0-订单筛选,
      packageName: selectedCrowdData.name, // 人群名
      peopleCrowdParam: { // { "esLabel": "", "pinId": "dd18bf3a8e0a2a3e53e2661c7fb53534" },
        esLabel: selectedCrowdData.esJson/** 官方标签筛选人群所需传参 */,
        pinId: selectedCrowdData.keyy, /** 手机号上传人群所需传参 */
      },
      size: selectedCrowdData.size, // 人群包大小
      orderCrowdParam: { telList: params.telList, condition: params.searchString }, // { "telList": ["手机号数组"], "condition": "搜索表单对象转字符串" },
      orderCrowdType: params.orderCrowdType, // 0-订单营销下的筛选类型 1-手动选择 2-查询结果,
      md5: selectedCrowdData.md5,
      smsAccount: smsTemplateInfo.smsAccount, // 模板列表带的值
      templateId: smsTemplateInfo.templateId, // 短信模板id
    };
    return formData;
  };

  /** 【校验】 营销表单数据 */
  const verifyData = (formData): boolean => {
    // 验证营销主题 - 非空
    if (!formData.name) {
      ShowMessageError('请填写营销主题', 'form_theme');
      return false;
    }

    // 验证执行时间 - 非空
    if (!+formData.excuteType && !formData.excuteTime) {
      ShowMessageError('请选择执行时间', 'form_theme');
      return false;
    }
    // 验证执行时间 - 非空
    if (!+formData.excuteType &&(moment(+formData.excuteTime).hour() < 9 || moment(+formData.excuteTime).hour() > 20 || (moment(+formData.excuteTime).hour() === 19 && moment(+formData.excuteTime).minute() > 50))) {//日常发送范围 大促需手动更改，此处需后端出一个接口校验当前时间
      ShowMessageError('当前时间不在短信发送时间范围内,请设置短信发送时间', 'form_theme');
      return false;
    }

    // 验证定时执行 - 非空
    switch (formData.excuteType) {
      case '0':
        break;
      case '1':
        if (!formData.excuteTime) {
          ShowMessageError('请选择定时执行时间', 'form_wait_time');
          return false;
        } else if(formData.excuteTime < moment().format('x')){
          ShowMessageError('执行时间应晚于当前时间', 'form_wait_time');
          return false;
        } else if(moment(+formData.excuteTime).hour() < 8 || moment(+formData.excuteTime).hour() > 22 || (moment(+formData.excuteTime).hour() === 22 && moment(+formData.excuteTime).minute() > 0)){//日常发送范围 大促需手动更改，此处需后端出一个接口校验当前时间
          ShowMessageError('请修改短信发送时间', 'form_wait_time');
          return false;
        }
    }
    // 验证人群选择 - 非空
    if (!selectedCrowdData.id) {
      ShowMessageError('请选择人群', 'form_crowd');
      return false;
    }

    if (!formData.smsContent) {
      ShowMessageError('请选择短信模板', 'form_smsContent');
      return false;
    }

    /** 短信内容中非法字符组成的数组 */
    const illegalityString = utils.stringVerification(formData.smsContent);
    // 验证短信内容 - 不允许存在非法字符
    if (illegalityString.length) {
      ShowMessageError(`您输入的短信内容中含有非法字符${illegalityString.join(' ')}请更改`, 'form_smsContent');
      return false;
    }

    // 验证 预计发送数是否大于用户当前账户余额数
    if (selectedCrowdData.size > currentBalance) {
      ShowMessageError('您的当前账户余额短信条数小于将要发送的短信条数，请充值后操作');
      return false;
    }

    return true;
  };

  /** 【提交】 营销表单数据 */
  const submitData = (): void => {
    // Message.loading('正在校验您将要提交的数据，请稍后...');

    const formData = packagingData();
    if (!verifyData(formData)) {
      return;
    }

    // 提交营销表单
    Servlets('postMarketingtask', formData).then((res: { success: boolean; data: object }) => {
      if (!res.success) {
        ShowMessageError(res.resp_msg, '');
      } else {
        setTimeout(() => {
          Message.success({ title: '校验成功，已完成数据提交！', duration: 1500 });
          Servlets('smsUseaccountAdd', { templateId: smsTemplateInfo.templateId }).then((res) => {
          }); // 短信模板使用次数加1
          appHistory.push('../crowdMarketing');
        }, 500);
      }
    });
  };

  /** 展示校验函数抛出的异常,并滚动至异常处 */
  const ShowMessageError = (error: string, elementId = '') => {
    setTimeout(() => {
      // 抛出Error
      Message.warning(error);

      if (!elementId) return;

      // 页面滚动至抛出Error处
      const formElement = document.getElementById(elementId);

      if (formElement) formElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
    }, 500);
  };

  // 二次发送右侧手机模式预览：(折行和空格同时跟随输入展示)
  useEffect(() => {
    let cont = messageContent || '';
    cont = cont?.replace(/\n/g, '<br/>');
    cont = cont?.replace(/\s/g, '&nbsp;');
    setPhoneMsgSecond(cont);
  }, [messageContent]);

  useEffect(()=>{
    const signs = messageSignatures ? `【${messageSignatures}】` : '【】';
    setMessageContent(signs);
  },[messageSignatures])
  /** 函数防抖 响应函数 */
  const responseFunc = (func, ...argu) => {
    utils.debounceImmediately(func)(argu); // 立即执行
  };
  const remainingDay = store.get('remainingDay');
  const disabledDate = function (date, view) {
    const endDate = new Date(new Date().setDate(new Date().getDate() + remainingDay)).getTime();
    const currentDate = new Date(new Date().setDate(new Date().getDate() - 1)); // 当前日期的前一天
    return date.valueOf() < currentDate.valueOf() || date.valueOf() > endDate;
  };

  return (
    <>
      <section className={style.mainBox}>
        <div className={style.container}>
          {/* 区块1 -  基础信息 */}
          <section className={style.moudle}>

            <SectionTitle attr-intro="段落标题" title="基础信息" preface="1" />

            <div className={style.controlArea}>
              <div className={style.form}>
                <label id="form_theme">
                  <span><span style={{ color: 'red' }}>*</span>营销主题：</span>
                  <Input
                    showLimitHint
                    maxLength={32}
                    placeholder="请输入..."
                    value={theme}
                    hasClear
                    onChange={setThemeValue}
                    style={{ width: 600 }}
                  />
                </label>

                <label style={{ marginTop: 24 }} id="form_time">
                  <span><span style={{ color: 'red' }}>*</span>执行时间：</span>
                  <RadioGroup dataSource={timeDisc} value={time} onChange={setTimeValue} />
                </label>
                {
                  time === 'wait'
                  &&
                  (<div style={{ margin: '24px 0 12px 0' }} id="form_wait_time">
                    <span style={{ marginRight: '12px' }}><span
                      style={{ color: 'red' }}
                    >*
                                                          </span>时间选择：
                    </span>
                    <DatePicker
                      type="date"
                      value={waitTime}
                      onChange={setWaitTimeValue}
                      showTime
                      style={{ width: 600 }}
                      disabledDate={disabledDate}
                      followTrigger
                    />
                  </div>)
                }
                <div />
              </div>
              <div className={style.infoText}>
                <div className={style.infoTextTitle}>
                  <Icon type="prompt" size="small" style={{ color: '#5D4CFF', marginRight: 8 }} />
                  <span>短信发送注意事项：</span>
                </div>
                <p> 1.短信发送时间范围为：9:00-20:00（日常）、早8:00-凌晨2点（大促）</p>
                <p> 2.营销短信每天给同一手机号发送不超过15条</p>
              </div>
            </div>
          </section>

          {/* 区块2 - 人群选择 */}
          <section className={style.moudle}>
            <SectionTitle attr-intro="段落标题" title="人群选择" preface="2" />

            <div className={`${style.controlArea} ${style.area_2}`}>
              <div className={style.form}>
                <div id="form_crowd">
                  <span style={{ paddingTop: 7 }}><span style={{ color: 'red' }}>*</span>人群选择：</span>
                  <div className={style.selectCrowd}>
                    <Button
                      type="primary"
                      style={{ width: 88 }}
                      onClick={() => {
                        setOpenCrowdSelectedDialog(true);
                      }}
                      disabled={(params.orderCrowdType==='2' || params.orderCrowdType==='1') ?true:false}
                    >选择人群
                    </Button>
                    <div className={style.selectBorder}>
                      <div className={style.select}>
                        <img src={icon_warning} alt="" />
                        <div className={style.showSelect}>
                          <span>{selectedCrowdData.name}</span>
                          <span
                            style={{ color: '#ddd' }}
                          >人群总人数{selectedCrowdData.id ? '' : '（未选择）'}
                          </span>
                          <span
                            style={{ color: '#ddd' }}
                          >{utils.numFormat_hjy(selectedCrowdData.size)}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                {/* <div style={{ marginTop: 12 }}>
                  <span style={{ paddingTop: 7 }}><span style={{ color: 'transparent' }}>*</span>屏蔽设置：</span>
                  <Checkbox.Group itemDirection="ver" value={shieldArr} onChange={handleCheckboxGroupChange}>
                    <Checkbox value="crowd">
                      屏蔽近&nbsp;&nbsp;
                        <Select value={shieldPopulation} onChange={handleSelectChange} dataSource={getDataSource()} style={{ width: 88 }} followTrigger autoHighlightFirstItem={false} />
                        &nbsp;&nbsp;天已营销人群
                    </Checkbox>
                    <Checkbox value="blackListing">屏蔽营销黑名单</Checkbox>
                  </Checkbox.Group>
                </div> */}
              </div>
            </div>
          </section>

          {/* 区块3 - 投放内容 */}
          <section className={style.moudle}>

            <SectionTitle attr-intro="段落标题" title="投放内容" preface="3" />

            <div className={`${style.controlArea} ${style.area_3}`}>
              <div className={style.form}>
                <label>
                  <span><span style={{ color: 'transparent' }}>*</span>短信签名：</span>
                  <Input
                    maxLength={32}
                    value={messageSignatures}
                    style={{ width: 600 }}
                    disabled
                  />
                </label>
                <div className={style.messageContent} style={{ display: 'flex' }} id="form_smsContent">
                  <span style={{ marginRight: 12, paddingTop: 7 }}><span
                    style={{ color: 'transparent' }}
                  >*
                  </span>短信内容：
                  </span>
                  <div className={style.messageLayout}>
                    <div className={style.setButton}>
                      {/* 21年8月，应对抖音官方调整，暂时调整功能 */}
                      {/* <Button type="primary" onClick={handleOpenShortUrlDialog}>短链接工具</Button> */}
                      <Button
                        type="secondary"
                        onClick={handleSelectSmsTemplateDialog}
                      >选择短信模板
                      </Button>
                    </div>

                    <div style={{ display: 'flex' }}>
                      <TextArea
                        disabled
                        className={'crowd-market-sms-create'}
                        maxLength={350}
                        value={messageContent}
                        onChange={handleTextAreaOnChange}
                      />

                      <div className={style.textArea}>
                        <div>已输入:{sizeLength}/350 字(包含签名)</div>
                        <div>当前计费：{everyMessageNum}条</div>
                        <Balloon
                          popupClassName="popupClassName"
                          align="t"
                          trigger={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <Button
                                type="primary"
                                text
                                style={{ float: 'right' }}
                              >计费及内容规则
                              </Button><img
                                src={icon_warning}
                                alt="提示"
                                style={{ width: 14, height: 14 }}
                              />
                            </div>}
                          closable={false}
                        >
                          <div>
                            <div style={{ fontWeight: 'bold' }}>说明</div>
                            <div>
                              1、70字计一条短信收费，超出70字按67字每条计,一个汉字，字母或者标点都算一个字<br/>
                              2、受短信运营商限制，签名和{CONSTANTS.LZ_SMS_CANCEL_WORD}，包含在字数中<br/>
                              3、请确保短链接【前后各加一个空格】，否则智能手机无法打开，使用短链接工具生成的短链已默认增加前后空格<br/>
                              4、请确保每条短信中只有一条短链接，否则无法统计短信发送情况<br/>
                              5、短信内容只能为普通字符，不能包含：【、】、）、表情符 等特殊字符
                            </div>
                          </div>
                        </Balloon>
                      </div>
                    </div>

                    <div className={style.textAreaPrompt}>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Icon
                          type="email"
                          size="small"
                          style={{ marginRight: '8px', color: '#9CA7B6' }}
                        />
                        <span>预计发送：{selectedCrowdData.size * everyMessageNum}条&emsp;&emsp;</span>
                        <span>当前账户余额：<span style={{ color: 'red' }}>{currentBalance}</span>条&nbsp;</span>
                        {
                          selectedCrowdData.size > currentBalance &&
                          <Balloon
                            popupClassName="popupClassName"
                            align="t"
                            trigger={
                              <div className={style.balanceBox}>
                                <span className={style.text}>余额不足</span>
                                <img src={icon_warning} alt="提示" style={{ width: 14, height: 14 }}/>
                              </div>
                            }
                            closable={false}
                          >
                            <div>
                              <div style={{ fontWeight: 'bold' }}>说明</div>
                              <div>1、发送100W条以上短信需要审核，审核时间是每日18点</div>
                              <div>2、短信发送时间范围为：早9:01-晚 19:59（日常）</div>
                              <div>3、所有商家每天给同一手机号发送营销短信条数不超过3条，所有商家两天内给同一手机号发送营销短信条数不超过5条，同一商家2天内给同一手机号发送营销短信条数不超过1条</div>
                            </div>
                          </Balloon>
                        }
                      </div>

                      <div>
                        <Button
                          type="primary"
                          text
                          onClick={immediatelyPrepaid}
                        >立即充值
                        </Button>&emsp;&emsp;
                        <Button
                          type="primary"
                          text
                          onClick={() => responseFunc(refreshPrepaid)}
                        >刷新余额
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <label style={{ marginLeft: '-60px' }}>
                  <span><span style={{ color: 'transparent' }}>*</span>测试短信接收人电话：</span>
                  <div className={style.setPhoneNum}>
                    {/* <Input placeholder="请输入..." maxLength={11} className={style.phone} hasClear style={{ width: "600px", marginRight: 10 }} /> */}
                    {/* <Select mode="multiple" placeholder="请输入..." defaultValue={['10001']} dataSource={[{ value: '10001', label: '18342216827' }, { value: '10002', label: '15941158869' }, { value: '10003', label: '18888888888' }]} style={{ marginRight: 10, minWidth: 513 }} /> */}
                    <Input
                      showLimitHint
                      maxLength={11}
                      placeholder="请输入..."
                      value={testTel}
                      hasClear
                      onChange={setTestTelFunc}
                      style={{ width: 600, marginRight: 10 }}
                    />
                    &nbsp;
                    <Button
                      type="secondary"
                      style={{ width: '88px' }}
                      onClick={() => responseFunc(sendTestTel)}
                    >发送测试
                    </Button>

                    {/* <Button type="primary" text style={{ margin: '0 14px' }} onClick={showModifyTelDialog}>修改测试手机号</Button> */}

                    {/* <Button type="primary" text style={{ marginLeft: '14px' }} onClick={() => setOpenTestTelRecordDialog(true)}>测试记录</Button> */}
                  </div>
                </label>
              </div>

              {/* <div className={style.preview} style={{ paddingLeft: 45 }}>
                                <img src="http://banner.dianpusoft.cn/sui/cjyx/DZ/images/%E4%BA%BA%E7%BE%A4%E8%90%A5%E9%94%80/u2175.png" alt="投放内容收集预览图" />
                            </div> */}
              <div attr-intro="短信签名-right" style={{ width: '30%' }}>
                <div className={style.phoneBox}>
                  <div className={style.phoneImg}>

                    <div
                      className={style.previewMessage}
                      dangerouslySetInnerHTML={{ __html: `${phoneMsgSecond}` }}
                    />

                  </div>
                  <div style={{
                    marginLeft: '130px',
                    width: '60px',
                    marginTop: '15px',
                    color: '#657180',
                  }}
                  >实时预览
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 底部按钮 */}
          <section>
            <div style={{ textAlign: 'right' }}>
              <Button
                type="normal"
                style={{ width: '88px' }}
                onClick={goBackPrePage}
              >取消
              </Button>&emsp;&emsp;
              <Button
                type="primary"
                style={{ width: '88px' }}
                onClick={() => responseFunc(submitData)}
              >确认创建
              </Button>
            </div>
          </section>
        </div>
        {/* 人群选择弹窗 */}
        <Dialog_CrowdSelected_List
          visible={openCrowdSelectedDialog}
          type='1,3,5,6,8,9,10'
          selected={(
            data: {
              id: string;
              name: string;
              intro: string;
              type: string;
              size: number;
              createDate: string;
            },
            selected: boolean,
          ) => {
            {
              getCrowdSelectedData(data, selected);
            }
          }}
        />

        {/* 生成短链接弹窗 */}
        <Dialog_GenerateShortURL
          visible={openShortUrlDialog}
          selected={(visible: boolean) => {
            setOpenShortUrlDialog(visible);
          }}
          getUrl={(url: { longUrl: ''; shortUrl: '' }) => {
            setUrl(url);
          }}
        />

        {/* 选择短信模板弹窗 */}
        <LzDialog
          isFullScreen
          shouldUpdatePosition
          visible={selectSmsTemplateDialog}
          footer={false}
          title="选择短信模板"
          onCancel={() => setSelectSmsTemplateDialog(false)}
          onClose={() => setSelectSmsTemplateDialog(false)}
          style={{ width: 1060 }}
        >
          <Dialog_CrowdSmsTemplate
            diySelect={(tem) => dealSmsContent(tem)}
            systemSelect={(tem) => dealSmsContent(tem)}
            historySelect={(tem) => dealSmsContent(tem)}
            modelTypeCode={'S_RQDX'}
          />
        </LzDialog>

        {/* 测试记录弹窗 */}
        {/* <Dialog_TestTelRecord visible={openTestTelRecordDialog} selected={(visible: boolean) => {
                    setOpenTestTelRecordDialog(visible)
                }} /> */}

        {/* 模态框 - 数据列表 */}
        <Dialog_SMSSendDetail
          visible={openTestTelRecordDialog}
          sendDetailData={{ type: 'test' }}
          selected={(visible: boolean) => {
            {
              setOpenTestTelRecordDialog(visible);
            }
          }}
        />
        <DisclaimerDialog />
      </section>

    </>
  );
};

export default Dialog_CreateShortMesssage_content;
